export const zobjectDeleted = (subpatch, {zobject}) => {
    subpatch.instances.forEach(
        instance => {
            let obj = instance.lookupObject(zobject);
            console.log("DELETING OBJ=", zobject, obj);
            if (obj) {
                obj.delete();
            }
        });
};

export const zmessageDeleted = (subpatch, {zmessage}) => {
    subpatch.instances.forEach(
        instance => {
            let obj = instance.lookupObject(zmessage);
            console.log("DELETING OBJ=", zmessage, obj);
            if (obj) {
                instance.deleteNode(obj);
            }
        });
};
